export default __webpack_public_path__ + "static/media/O-154.b5a571b4.png";